import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	loadTranslationPayloadType,
	TranslationType,
} from '../../types/state/translationTypes'
import enTranslations from '../../constants/en.json'
import mrTranslations from '../../constants/mr.json'

const initialState: TranslationType = {
	data: enTranslations,
	selectedLanguage: 'en',
}

export const translationSlice = createSlice({
	name: 'translation',
	initialState,
	reducers: {
		loadTranslations: (
			state,
			action: PayloadAction<loadTranslationPayloadType>
		) => {
			state.data = action.payload.language ? mrTranslations : enTranslations
			state.selectedLanguage = action.payload.language ? 'mr' : 'en'
		},
		resetTranslations: (state) => {
			state.data = initialState.data
			state.selectedLanguage = initialState.selectedLanguage
		},
	},
})

export const { loadTranslations, resetTranslations } = translationSlice.actions

export default translationSlice.reducer
